import { API_URL } from '../constants/url.js'

export const converPath = (path) => {
    console.log(`${API_URL}/${path}`)
    return `${API_URL}/${path}`
}
